(function () {
  /** Runs before DOM ready so variant-picker always has a callable (carousel or single image). */
  function zoonyGalleryGoToFallback(index) {
    var root = document.getElementById('zoony-product-hero');
    var idx = typeof index === 'number' && !Number.isNaN(index) ? Math.floor(index) : 0;
    var dataEl = document.getElementById('zoony-product-gallery-data');
    var urls = [];
    if (dataEl) {
      try {
        urls = JSON.parse(dataEl.textContent.trim());
      } catch (e) {
        urls = [];
      }
    }
    if (!Array.isArray(urls) || urls.length === 0) return;
    if (idx < 0) idx = 0;
    if (idx >= urls.length) idx = urls.length - 1;
    var carousel = root && root.querySelector('[data-zoony-main-carousel]');
    var mainImg = document.getElementById('mainImg');
    if (carousel) {
      var behavior = 'smooth';
      function tryScroll() {
        var w = carousel.clientWidth;
        if (w <= 0) return false;
        carousel.scrollTo({ left: idx * w, behavior: behavior });
        return true;
      }
      if (!tryScroll()) {
        requestAnimationFrame(function () {
          if (!tryScroll()) {
            requestAnimationFrame(function () {
              if (!tryScroll()) {
                setTimeout(function () {
                  if (!tryScroll() && mainImg && urls[idx]) mainImg.src = urls[idx];
                }, 120);
              }
            });
          }
        });
      }
    } else if (mainImg && urls[idx]) {
      mainImg.src = urls[idx];
    }
    if (root) {
      root.querySelectorAll('[data-zoony-thumb]').forEach(function (t) {
        var i = Number(t.getAttribute('data-index'));
        var on = i === idx;
        t.classList.toggle('active', on);
        t.setAttribute('aria-current', on ? 'true' : 'false');
      });
    }
  }

  window.zoonyProductGalleryGoTo = zoonyGalleryGoToFallback;

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  onReady(function () {
    var root = document.getElementById('zoony-product-hero');
    var dataEl = document.getElementById('zoony-product-gallery-data');
    var viewer = document.getElementById('zoonyProductLightbox');
    var rail = document.getElementById('zoonyFsRail');

    if (!root || !viewer || !rail) return;

    var slides = rail.querySelectorAll('.zoony-fs-viewer__slide');
    var n = slides.length;
    if (n === 0) return;

    var urls = [];
    if (dataEl) {
      try {
        urls = JSON.parse(dataEl.textContent.trim());
      } catch (e) {
        urls = [];
      }
    }
    if (!Array.isArray(urls)) urls = [];

    var carousel = root.querySelector('[data-zoony-main-carousel]');
    var thumbs = root.querySelectorAll('[data-zoony-thumb]');
    var mainImg = document.getElementById('mainImg');
    var currentIndex = 0;
    var scrollRaf = 0;
    var scrollEndTimer;
    var railRaf = 0;
    var railEndTimer;

    function syncThumbs() {
      thumbs.forEach(function (t) {
        var idx = Number(t.getAttribute('data-index'));
        var on = idx === currentIndex;
        t.classList.toggle('active', on);
        t.setAttribute('aria-current', on ? 'true' : 'false');
      });
    }

    function clampIndex(i) {
      if (i < 0) i = 0;
      if (i >= n) i = n - 1;
      return i;
    }

    function wrap(i) {
      return ((i % n) + n) % n;
    }

    function scrollMainTo(i, smooth) {
      i = wrap(i);
      var behavior = smooth === true ? 'smooth' : 'auto';
      if (carousel) {
        function applyCarouselScroll() {
          var w = carousel.clientWidth;
          if (w <= 0) return false;
          carousel.scrollTo({ left: i * w, behavior: behavior });
          return true;
        }
        function finishIndex() {
          currentIndex = i;
          syncThumbs();
        }
        if (applyCarouselScroll()) {
          finishIndex();
        } else {
          requestAnimationFrame(function () {
            if (applyCarouselScroll()) {
              finishIndex();
            } else {
              requestAnimationFrame(function () {
                if (applyCarouselScroll()) {
                  finishIndex();
                } else {
                  setTimeout(function () {
                    if (applyCarouselScroll()) {
                      finishIndex();
                    } else if (mainImg && urls[i]) {
                      mainImg.src = urls[i];
                      finishIndex();
                    }
                  }, 120);
                }
              });
            }
          });
        }
        return;
      }
      if (mainImg && urls[i]) {
        mainImg.src = urls[i];
      }
      currentIndex = i;
      syncThumbs();
    }

    function readIndexFromCarousel() {
      if (!carousel || !viewer.hasAttribute('hidden')) return;
      var w = carousel.clientWidth;
      if (w <= 0) return;
      var i = clampIndex(Math.round(carousel.scrollLeft / w));
      if (i !== currentIndex) {
        currentIndex = i;
        syncThumbs();
      }
    }

    function onCarouselScroll() {
      if (!carousel) return;
      if (scrollRaf) cancelAnimationFrame(scrollRaf);
      scrollRaf = requestAnimationFrame(function () {
        scrollRaf = 0;
        readIndexFromCarousel();
      });
    }

    function readIndexFromRail() {
      var w = rail.clientWidth;
      if (w <= 0) return;
      var i = clampIndex(Math.round(rail.scrollLeft / w));
      if (i !== currentIndex) {
        currentIndex = i;
        syncThumbs();
        scrollMainTo(i, false);
      }
    }

    function onRailScroll() {
      if (railRaf) cancelAnimationFrame(railRaf);
      railRaf = requestAnimationFrame(function () {
        railRaf = 0;
        readIndexFromRail();
      });
    }

    function snapRailTo(i) {
      i = wrap(i);
      var w = rail.clientWidth;
      if (w <= 0) return;
      rail.scrollTo({ left: i * w, behavior: 'auto' });
      currentIndex = i;
      syncThumbs();
      scrollMainTo(i, false);
    }

    function openViewer(startIndex) {
      currentIndex = clampIndex(startIndex);
      if (viewer.parentNode !== document.body) {
        document.body.appendChild(viewer);
      }
      viewer.removeAttribute('hidden');
      viewer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('zoony-product-lightbox-open');
      rail.focus({ preventScroll: true });
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          snapRailTo(currentIndex);
        });
      });
    }

    function closeViewer() {
      viewer.setAttribute('hidden', '');
      viewer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('zoony-product-lightbox-open');
    }

    function goTo(i) {
      scrollMainTo(i, true);
      if (!viewer.hasAttribute('hidden')) {
        snapRailTo(i);
      }
    }

    if (carousel) {
      carousel.addEventListener('scroll', onCarouselScroll, { passive: true });
      if ('onscrollend' in window) {
        carousel.addEventListener('scrollend', readIndexFromCarousel);
      } else {
        carousel.addEventListener('scroll', function () {
          clearTimeout(scrollEndTimer);
          scrollEndTimer = setTimeout(readIndexFromCarousel, 80);
        });
      }
    }

    rail.addEventListener('scroll', onRailScroll, { passive: true });
    if ('onscrollend' in window) {
      rail.addEventListener('scrollend', readIndexFromRail);
    } else {
      rail.addEventListener('scroll', function () {
        clearTimeout(railEndTimer);
        railEndTimer = setTimeout(readIndexFromRail, 80);
      });
    }

    window.addEventListener(
      'resize',
      function () {
        if (!viewer.hasAttribute('hidden')) {
          snapRailTo(currentIndex);
        } else if (carousel) {
          clearTimeout(scrollEndTimer);
          scrollEndTimer = setTimeout(function () {
            scrollMainTo(currentIndex, false);
          }, 100);
        }
      },
      { passive: true }
    );

    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = Number(btn.getAttribute('data-index'));
        if (!Number.isNaN(idx)) goTo(idx);
      });
    });

    root.addEventListener('click', function (e) {
      var zoom = e.target.closest('[data-zoony-open-lightbox]');
      if (!zoom || !root.contains(zoom)) return;
      var start = currentIndex;
      var slide = zoom.closest('[data-slide-index]');
      if (slide) {
        var idx = Number(slide.getAttribute('data-slide-index'));
        if (!Number.isNaN(idx)) start = idx;
      } else if (carousel) {
        var cw = carousel.clientWidth;
        start = cw > 0 ? clampIndex(Math.round(carousel.scrollLeft / cw)) : 0;
      }
      openViewer(start);
    });

    root.querySelectorAll('[data-zoony-prev]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.stopPropagation();
        goTo(currentIndex - 1);
      });
    });
    root.querySelectorAll('[data-zoony-next]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.stopPropagation();
        goTo(currentIndex + 1);
      });
    });

    viewer.querySelectorAll('[data-zoony-fs-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        closeViewer();
      });
    });

    function fsScrollStep(dir) {
      var w = rail.clientWidth;
      if (w <= 0) return;
      rail.scrollBy({ left: dir * w, behavior: 'smooth' });
    }

    viewer.querySelectorAll('[data-zoony-fs-prev]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.stopPropagation();
        fsScrollStep(-1);
      });
    });
    viewer.querySelectorAll('[data-zoony-fs-next]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.stopPropagation();
        fsScrollStep(1);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (viewer.hasAttribute('hidden')) return;
      if (e.key === 'Escape') {
        closeViewer();
        return;
      }
      var w = rail.clientWidth;
      if (w <= 0) return;
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        rail.scrollBy({ left: -w, behavior: 'smooth' });
      }
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        rail.scrollBy({ left: w, behavior: 'smooth' });
      }
    });

    requestAnimationFrame(function () {
      readIndexFromCarousel();
    });

    window.zoonyProductGalleryGoTo = function (index) {
      goTo(typeof index === 'number' && !Number.isNaN(index) ? index : 0);
    };
  });
})();
